import {dhtmlXCalendarObject} from './dhtmlXCalendarObject';
import {GoingUtils} from 'goingutils';

dhtmlXCalendarObject.prototype.setSkin = function (u, a) {
    if (this.conf.skin == u && !a) {
        return;
    }
    this.conf.skin = u;
    this.base.className = "dhtmlxcalendar_" + this.conf.skin;
    this._ifrSize();
};
dhtmlXCalendarObject.prototype.loadUserLanguage = function (x) {
    if (!this.langData[x]) {
        return;
    }
    this.lang = x;
    this.setWeekStartDay(this.langData[this.lang].weekstart);
    this.setDateFormat(this.langData[this.lang].dateformat || "%Y-%m-%d");
    if (this.msCont) {
        var v = 0;
        for (var u = 0; u < this.msCont.childNodes.length; u++) {
            for (var a = 0; a < this.msCont.childNodes[u].childNodes.length; a++) {
                this.msCont.childNodes[u].childNodes[a].innerHTML = this.langData[this.lang].monthesSNames[v++];
            }
        }
    }
    this.contTime.childNodes[0].childNodes[0].childNodes[5].innerHTML = this.langData[this.lang].today;
    this.contTime.childNodes[0].childNodes[0].childNodes[4].innerHTML = this.langData[this.lang].clear;
};
dhtmlXCalendarObject.prototype.setParent = function (a) {
    if (this._hasParent) {
        if (typeof a == "object") {
            a.appendChild(this.base);
        } else {
            if (typeof a == "string") {
                document.getElementById(a).appendChild(this.base);
            }
        }
    }
};
dhtmlXCalendarObject.prototype.setWeekStartDay = function (a) {
    if (a == 0) {
        a = 7;
    }
    this._wStart = Math.min(Math.max(isNaN(a) ? 1 : a, 1), 7);
    this._drawDaysOfWeek();
};
dhtmlXCalendarObject.prototype._drawDaysOfWeek = function () {
    var x = null;
    if (this.contDays.childNodes.length == 0) {
        x = document.createElement("UL");
        x.className = "dhtmlxcalendar_line";
        this.contDays.appendChild(x);
    } else {
        x = this.contDays.firstChild;
    }
    var u = this._wStart;
    var v = this.langData[this.lang].daysSNames;
    v.push(String(this.langData[this.lang].daysSNames[0]).valueOf());
    var a = null;
    for (var y = 0; y < 8; y++) {
        if (x.childNodes[y] == null) {
            a = document.createElement("LI");
            x.appendChild(a);
        } else {
            a = x.childNodes[y];
        }
        if (y == 0) {
            a.className = "dhtmlxcalendar_cell_wn";
            a.innerHTML =
                "<div class='dhtmlxcalendar_label'>" +
                (this.langData[this.lang].weekname || "w") +
                "</div>";
        } else {
            a.className =
                "dhtmlxcalendar_cell" +
                (u >= 6 ? " dhtmlxcalendar_day_weekday_cell" : "") +
                (y == 1 ? "_first" : "");
            a.innerHTML = v[u];
            if (++u > 7) {
                u = 1;
            }
        }
    }
    if (this._activeMonth != null) {
        this._drawMonth(this._activeMonth);
    }
};
dhtmlXCalendarObject.prototype.showTime = function () {
    if (this.conf.time != true) {
        this.conf.time = true;
        this._adjustTimeCont();
    }
};
dhtmlXCalendarObject.prototype.hideTime = function () {
    if (this.conf.time == true) {
        this.conf.time = false;
        this._adjustTimeCont();
    }
};
dhtmlXCalendarObject.prototype.showToday = function () {
    if (this.conf.today != true) {
        this.conf.today = true;
        this._adjustTimeCont();
    }
};
dhtmlXCalendarObject.prototype.hideToday = function () {
    if (this.conf.today == true) {
        this.conf.today = false;
        this._adjustTimeCont();
    }
};
dhtmlXCalendarObject.prototype._adjustTimeCont = function () {
    var a = "";
    if (this.conf.time == true) {
        a += "_time";
    }
    if (this.conf.today == true) {
        a += "_today";
    }
    if (a == "") {
        this.contTime.style.display = "none";
    } else {
        this.contTime.className =
            "dhtmlxcalendar_time_cont dhtmlxcalendar_mode" + a;
        this.contTime.style.display = "";
    }
    this._ifrSize();
};
dhtmlXCalendarObject.prototype.setDate = function (u) {
    dhx4.temp_calendar = {tz: null};
    this._nullDate = typeof u == "undefined" || u === "" || !u;
    if (!(u instanceof Date)) {
        u = this._strToDate(String(u || ""));
        if (u == "Invalid Date") {
            u = new Date();
        } else {
            this.conf.tz = dhx4.temp_calendar.tz;
        }
        dhx4.temp_calendar = null;
    }
    if (this.conf.tz == null) {
        this.conf.tz = dhx4.date2str(u, "%P");
    }
    var a = u.getTime();
    if (this._isOutOfRange(a)) {
        return;
    }
    this._activeDate = new Date(a);
    this._drawMonth(this._nullDate ? new Date() : this._activeDate);
    this._updateVisibleHours();
    this._updateVisibleMinutes();
};
dhtmlXCalendarObject.prototype.getDate = function (v) {
    if (this._nullDate) {
        return null;
    }
    var a = new Date(this._activeDate.getTime());
    if (v) {
        dhx4.temp_calendar = {tz: this.conf.tz};
        var u = this._dateToStr(a);
        dhx4.temp_calendar = null;
        return u;
    }
    return a;
};
dhtmlXCalendarObject.prototype._drawMonth = function (F) {
    if (!(F instanceof Date)) {
        return;
    }
    if (isNaN(F.getFullYear())) {
        F = new Date(this._activeMonth.getFullYear(), this._activeMonth.getMonth(), 1, 0, 0, 0, 0);
    }
    this._activeMonth = new Date(F.getFullYear(), F.getMonth(), 1, 0, 0, 0, 0);
    this._activeDateCell = null;
    var D = new Date(this._activeMonth.getTime());
    var v = D.getDay();
    var J = v - this._wStart;
    if (J < 0) {
        J = J + 7;
    }
    D.setDate(D.getDate() - J);
    var M = F.getMonth();
    var N = new Date(this._activeDate.getFullYear(), this._activeDate.getMonth(), this._activeDate.getDate(), 0, 0, 0, 0).getTime();
    var A = 0;
    for (var u = 0; u < 6; u++) {
        var E = this._wStart;
        for (var L = 0; L <= 7; L++) {
            if (L == 0) {
                var K = this.getWeekNumber(new Date(D.getFullYear(), D.getMonth(), D.getDate() + A, 0, 0, 0, 0));
                if (K >= 52 &&
                    this.conf.ws_first == true &&
                    this._activeMonth.getMonth() == 0) {
                    var y = this.getWeekNumber(new Date(D.getFullYear(), D.getMonth(), D.getDate() + A + 7, 0, 0, 0, 0));
                    if (y < K && y > 1) {
                        K = 1;
                    }
                }
                this.contDates.childNodes[u].childNodes[L].innerHTML =
                    "<div class='dhtmlxcalendar_label'>" + K + "</div>";
            } else {
                var a = new Date(D.getFullYear(), D.getMonth(), D.getDate() + A, 0, 0, 0, 0);
                if (a.getHours() != 0) {
                    var C = a.getHours() > 12 ? 24 - a.getHours() : a.getHours();
                    a.setTime(a.getTime() + 60 * 60 * 1000 * C);
                }
                var I = a.getDay();
                var x = a.getTime();
                var H = "dhtmlxcalendar_label";
                if (this._tipData[x] != null) {
                    if (this._tipData[x].usePopup && typeof window.dhtmlXPopup == "function") {
                        this.contDates.childNodes[u].childNodes[L].removeAttribute("title");
                        this._initTooltipPopup();
                    } else {
                        this.contDates.childNodes[u].childNodes[L].setAttribute("title", this._tipData[x].text);
                    }
                    if (this._tipData[x].showIcon) {
                        H += " dhtmlxcalendar_label_title";
                    }
                } else {
                    this.contDates.childNodes[u].childNodes[L].removeAttribute("title");
                }
                this.contDates.childNodes[u].childNodes[L].innerHTML =
                    "<div class='" + H + "'>" + a.getDate() + "</div>";
                this.contDates.childNodes[u].childNodes[L]._date = new Date(x);
                this.contDates.childNodes[u].childNodes[L]._q = u;
                this.contDates.childNodes[u].childNodes[L]._w = L;
                this.contDates.childNodes[u].childNodes[L]._css_month =
                    a.getMonth() == M;
                this.contDates.childNodes[u].childNodes[L]._css_date =
                    !this._nullDate && x == N;
                this.contDates.childNodes[u].childNodes[L]._css_weekend = E >= 6;
                this.contDates.childNodes[u].childNodes[L]._css_dis = this._isOutOfRange(x);
                this.contDates.childNodes[u].childNodes[L]._css_holiday =
                    this._holidays[x] == true;
                this._updateCellStyle(u, L);
                if (x == N) {
                    this._activeDateCell = this.contDates.childNodes[u].childNodes[L];
                }
                if (++E > 7) {
                    E = 1;
                }
                A++;
            }
        }
    }
    this.contMonth.firstChild.firstChild.childNodes[1].innerHTML = this._buildMonthHdr(F);
};
dhtmlXCalendarObject.prototype._updateCellStyle = function (x, a) {
    var v = this.contDates.childNodes[x].childNodes[a];
    var u = "dhtmlxcalendar_cell dhtmlxcalendar_cell";
    u += v._css_month ? "_month" : "";
    u += v._css_date ? "_date" : "";
    u += v._css_weekend ? "_weekend" : "";
    u += v._css_holiday ? "_holiday" : "";
    u += v._css_dis ? "_dis" : "";
    u += v._css_hover && !v._css_dis ? "_hover" : "";
    v.className = u;
    v = null;
};
dhtmlXCalendarObject.prototype._showSelector = function (A, u, C, w, a) {
    if (a === true &&
        this._sel != null &&
        this._isSelectorVisible() &&
        A == this._sel._t) {
        this._hideSelector();
        return;
    }
    if (this.conf.skin == "dhx_terrace") {
        u += 12;
    }
    if (!this._sel || !this._sel._ta[A]) {
        this._initSelector(A, w);
    }
    if (A != this._sel._t &&
        this._sel._t == "minutes" &&
        this._minutesInterval == 1) {
        this.contTime.firstChild.firstChild.childNodes[3].innerHTML = this.getFormatedDate("%i");
    }
    this._sel._x = u;
    this._sel._y = C;
    this._sel.style.visibility = "hidden";
    this._sel.style.display = "";
    this._selCover.style.width = this.base.offsetWidth - 2 + "px";
    this._selCover.style.top = this.contMonth.offsetHeight + "px";
    this._selCover.style.height =
        this.contDates.offsetHeight + this.contDays.offsetHeight - 1 + "px";
    this._selCover.style.display = "";
    this._sel._t = A;
    this._sel.className =
        "dhtmlxcalendar_selector_obj dhtmlxcalendar_" +
        w +
        (A == "hours" && this.conf.today == true ? "2" : "");
    this._sel.childNodes[0].firstChild.firstChild.childNodes[0].style.display = this._sel.childNodes[0].firstChild.firstChild.childNodes[2].style.display =
        A == "year" ? "" : "none";
    var v = Math.max(0, u - Math.round(this._sel.offsetWidth / 2));
    if (v + this._sel.offsetWidth > this._sel.parentNode.offsetWidth) {
        v = this._sel.parentNode.offsetWidth - this._sel.offsetWidth;
    }
    this._sel.style.left = v + "px";
    if (A == "hours" || A == "minutes") {
        this._sel.style.top = C - this._sel.offsetHeight + "px";
    } else {
        this._sel.style.top = C + "px";
    }
    this._sel.childNodes[1].style.width =
        this._sel.childNodes[0].offsetWidth + "px";
    this._sel.style.visibility = "visible";
    this._doOnSelectorShow(A);
};
dhtmlXCalendarObject.prototype._doOnSelectorShow = function (a) {
    if (a == "month") {
        this._updateActiveMonth();
    }
    if (a == "year") {
        this._updateYearsList(this._activeMonth);
    }
    if (a == "hours") {
        this._updateActiveHours();
    }
    if (a == "minutes") {
        this._updateActiveMinutes();
    }
};
dhtmlXCalendarObject.prototype._hideSelector = function (a) {
    if (!this._sel) {
        return;
    }
    this._sel.style.display = "none";
    this._sel.style.visible = "hidden";
    this._selCover.style.display = "none";
    if (this._sel._t == "minutes" && this._minutesInterval == 1) {
        this.contTime.firstChild.firstChild.childNodes[3].innerHTML = this.getFormatedDate("%i");
        this._unloadSelector("minutes");
    }
};
dhtmlXCalendarObject.prototype._isSelectorVisible = function () {
    if (!this._sel) {
        return false;
    }
    return this._sel.style.display != "none";
};
dhtmlXCalendarObject.prototype._doOnSelectorChange = function (a) {
    this.callEvent("onChange", [
        new Date(this._activeMonth.getFullYear(), this._activeMonth.getMonth(), this._activeDate.getDate(), this._activeDate.getHours(), this._activeDate.getMinutes(), this._activeDate.getSeconds()),
        a === true
    ]);
};
dhtmlXCalendarObject.prototype._clearSelHover = function () {
    if (!this._selHover) {
        return;
    }
    this._selHover.className = String(this._selHover.className.replace(/dhtmlxcalendar_selector_cell_hover/gi, ""));
    this._selHover = null;
};
dhtmlXCalendarObject.prototype._unloadSelector = function (v) {
    if (!this._sel) {
        return;
    }
    if (!this._sel._ta[v]) {
        return;
    }
    if (v == "month") {
        this.msCont.onclick = this.msCont.ontouchstart = null;
        this._msActive = null;
        for (var u in this._msCells) {
            this._msCells[u]._cell = null;
            this._msCells[u]._month = null;
            this._msCells[u].parentNode.removeChild(this._msCells[u]);
            this._msCells[u] = null;
        }
        this._msCells = null;
        while (this.msCont.childNodes.length > 0) {
            this.msCont.removeChild(this.msCont.lastChild);
        }
        this.msCont.parentNode.removeChild(this.msCont);
        this.msCont = null;
    }
    if (v == "year") {
        this.ysCont.onclick = this.ysCont.ontouchstart = null;
        for (var u_1 in this._ysCells) {
            this._ysCells[u_1]._cell = null;
            this._ysCells[u_1]._year = null;
            this._ysCells[u_1].parentNode.removeChild(this._ysCells[u_1]);
            this._ysCells[u_1] = null;
        }
        this._ysCells = null;
        while (this.ysCont.childNodes.length > 0) {
            this.ysCont.removeChild(this.ysCont.lastChild);
        }
        this.ysCont.parentNode.removeChild(this.ysCont);
        this.ysCont = null;
    }
    if (v == "hours") {
        this.hsCont.onclick = this.hsCont.ontouchstart = null;
        this._hsActive = null;
        for (var u_2 in this._hsCells) {
            this._hsCells[u_2]._cell = null;
            this._hsCells[u_2]._hours = null;
            this._hsCells[u_2].parentNode.removeChild(this._hsCells[u_2]);
            this._hsCells[u_2] = null;
        }
        this._hsCells = null;
        while (this.hsCont.childNodes.length > 0) {
            this.hsCont.removeChild(this.hsCont.lastChild);
        }
        this.hsCont.parentNode.removeChild(this.hsCont);
        this.hsCont = null;
    }
    if (v == "minutes") {
        this.rsCont.onclick = this.rsCont.ontouchstart = null;
        this._rsActive = null;
        for (var u_3 in this._rsCells) {
            this._rsCells[u_3]._cell = null;
            this._rsCells[u_3]._minutes = null;
            this._rsCells[u_3].parentNode.removeChild(this._rsCells[u_3]);
            this._rsCells[u_3] = null;
        }
        this._rsCells = null;
        while (this.rsCont.childNodes.length > 0) {
            this.rsCont.removeChild(this.rsCont.lastChild);
        }
        this.rsCont.parentNode.removeChild(this.rsCont);
        this.rsCont = null;
    }
    this._sel._ta[v] = null;
};
dhtmlXCalendarObject.prototype.setMinutesInterval = function (a) {
    if (!(a == 1 || a == 5 || a == 10 || a == 15)) {
        return;
    }
    this._minutesInterval = a;
    this._unloadSelector("minutes");
};
dhtmlXCalendarObject.prototype._updateActiveMonth = function () {
    if (typeof this._msActive != "undefined" &&
        typeof this._msCells[this._msActive] != "undefined") {
        this._msCells[this._msActive].className = "dhtmlxcalendar_selector_cell";
    }
    this._msActive = this._activeMonth.getMonth();
    this._msCells[this._msActive].className =
        "dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active";
};
dhtmlXCalendarObject.prototype._updateActiveYear = function () {
    var a = this._activeMonth.getFullYear();
    if (this._ysCells[a]) {
        this._ysCells[a].className =
            "dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active";
    }
};
dhtmlXCalendarObject.prototype._updateYearsList = function (A) {
    for (var v in this._ysCells) {
        this._ysCells[v] = null;
        delete this._ysCells[v];
    }
    var x = 12 * Math.floor(A.getFullYear() / 12);
    for (var y = 0; y < 4; y++) {
        for (var u = 0; u < 3; u++) {
            this.ysCont.childNodes[y].childNodes[u].innerHTML = x;
            this.ysCont.childNodes[y].childNodes[u]._year = x;
            this.ysCont.childNodes[y].childNodes[u].className =
                "dhtmlxcalendar_selector_cell";
            this._ysCells[x++] = this.ysCont.childNodes[y].childNodes[u];
        }
    }
    this._updateActiveYear();
};
dhtmlXCalendarObject.prototype._scrollYears = function (a) {
    var v = (a < 0
        ? this.ysCont.firstChild.firstChild._year
        : this.ysCont.lastChild.lastChild._year) + a;
    var u = new Date(v, this._activeMonth.getMonth(), 1, 0, 0, 0, 0);
    this._updateYearsList(u);
};
dhtmlXCalendarObject.prototype._updateActiveHours = function () {
    if (typeof this._hsActive != "undefined" &&
        typeof this._hsCells[this._hsActive] != "undefined") {
        this._hsCells[this._hsActive].className = "dhtmlxcalendar_selector_cell";
    }
    this._hsActive = this._activeDate.getHours();
    this._hsCells[this._hsActive].className =
        "dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active";
};
dhtmlXCalendarObject.prototype._updateVisibleHours = function () {
    this.contTime.firstChild.firstChild.childNodes[1].innerHTML = this._fixLength(this._activeDate.getHours(), 2);
};
dhtmlXCalendarObject.prototype._updateActiveMinutes = function () {
    if (this._rsActive != null &&
        typeof this._rsActive != "undefined" &&
        typeof this._rsCells[this._rsActive] != "undefined") {
        this._rsCells[this._rsActive].className = "dhtmlxcalendar_selector_cell";
    }
    if (this._minutesInterval == 1) {
        this._rsActive = this.getFormatedDate("%i")
            .toString()
            .charAt(this._selectorMode == 1 ? 0 : 1);
    } else {
        this._rsActive = this._activeDate.getMinutes();
    }
    if (typeof this._rsCells[this._rsActive] != "undefined") {
        this._rsCells[this._rsActive].className =
            "dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active";
    }
};
dhtmlXCalendarObject.prototype._updateVisibleMinutes = function (u) {
    var a = this._fixLength(this._activeDate.getMinutes(), 2).toString();
    if (u == true) {
        a =
            a.charAt(0) +
            "<span class='dhtmlxcalendar_selected_date'>" +
            a.charAt(1) +
            "</span>";
    }
    this.contTime.firstChild.firstChild.childNodes[3].innerHTML = a;
    if (u == true) {
        this.contTime.firstChild.firstChild.childNodes[3].lastChild._par = true;
    }
};
dhtmlXCalendarObject.prototype._fixLength = function (a, u) {
    while (String(a).length < u) {
        a = "0" + String(a);
    }
    return a;
};
dhtmlXCalendarObject.prototype._updateDateStr = function (u) {
    if (!this._dateFormatRE || !u.match(this._dateFormatRE)) {
        return;
    }
    if (u == this.getFormatedDate()) {
        return;
    }
    var a = this._strToDate(u);
    if (!(a instanceof Date)) {
        return;
    }
    if (this.checkEvent("onBeforeChange")) {
        if (!this.callEvent("onBeforeChange", [
            new Date(a.getFullYear(), a.getMonth(), a.getDate(), a.getHours(), a.getMinutes(), a.getSeconds())
        ])) {
            this._updateInp();
            return;
        }
    }
    this._nullDate = false;
    this._activeDate = a;
    this._drawMonth(this._nullDate ? new Date() : this._activeDate);
    this._updateVisibleMinutes();
    this._updateVisibleHours();
    if (this._sel && this._isSelectorVisible()) {
        this._doOnSelectorShow(this._sel._t);
    }
    this._doOnSelectorChange(true);
};
dhtmlXCalendarObject.prototype.showMonth = function (a) {
    if (typeof a == "string") {
        a = this._strToDate(a);
    }
    if (!(a instanceof Date)) {
        return;
    }
    this._drawMonth(a);
};
dhtmlXCalendarObject.prototype.setFormatedDate = function (x, y, u, w) {
    var v = this._strToDate(y, x);
    if (w) {
        return v;
    }
    this.setDate(v);
};
dhtmlXCalendarObject.prototype.getFormatedDate = function (u, a) {
    if (!(a && a instanceof Date)) {
        if (this._nullDate) {
            return "";
        }
        a = new Date(this._activeDate);
    }
    return this._dateToStr(a, u);
};
dhtmlXCalendarObject.prototype.getWeekNumber = function (y) {
    if (typeof y == "string") {
        y = this._strToDate(y);
    }
    if (!(y instanceof Date)) {
        return "Invalid Date";
    }
    if (typeof this._ftDay == "undefined") {
        this._ftDay = 4;
    }
    var H = this._wStart;
    var x = H + 7;
    var F = 4;
    var v = new Date(y.getFullYear(), 0, 1, 0, 0, 0, 0);
    var w = v.getDay();
    if (w == 0) {
        w = 7;
    }
    if (F < H) {
        F += 7;
        w += 7;
    }
    var D = 0;
    if (w >= H && w <= F) {
        console.log("----");
    } else {
        D = 1;
    }
    var C = w - H;
    var E = new Date(y.getFullYear(), 0, 1 - C + D * 7, 0, 0, 0, 0);
    var J = 604800000;
    var u = new Date(y.getFullYear(), y.getMonth(), y.getDate() + 1, 0, 0, 0, 0);
    var I = Math.ceil((u.getTime() - E.getTime()) / J);
    if (I == 0) {
        var A = new Date(y.getFullYear(), y.getMonth(), y.getDate(), 0, 0, 0, 0);
        var a = A.getDay() - this._wStart;
        if (a < 0) {
            a = a + 7;
        }
        A.setDate(A.getDate() - a);
        I = this.getWeekNumber(A);
    }
    return I;
};
dhtmlXCalendarObject.prototype.showWeekNumbers = function () {
    this.base.firstChild.className = "dhtmlxcalendar_wn";
};
dhtmlXCalendarObject.prototype.hideWeekNumbers = function () {
    this.base.firstChild.className = "";
};
dhtmlXCalendarObject.prototype.show = function (w) {
    if (!w && this._hasParent) {
        this._show();
        return;
    }
    if (typeof w == "string") {
        var v = document.getElementById(w);
        if (v != null &&
            typeof v._dhtmlxcalendar_uid != "undefined" &&
            this.i[v._dhtmlxcalendar_uid] != null) {
            this._show(v._dhtmlxcalendar_uid);
            return;
        }
    }
    if (typeof w == "object" &&
        typeof w._dhtmlxcalendar_uid != "undefined" &&
        this.i[w._dhtmlxcalendar_uid] == w) {
        this._show(w._dhtmlxcalendar_uid);
        return;
    }
    if (typeof w == "undefined") {
        for (var u in this.i) {
            if (!w) {
                w = u;
            }
        }
    }
    if (!w) {
        return;
    }
    this._show(w);
};
dhtmlXCalendarObject.prototype.hide = function () {
    if (this._isVisible()) {
        this._hide();
    }
};
dhtmlXCalendarObject.prototype.isVisible = function () {
    return this._isVisible();
};
dhtmlXCalendarObject.prototype.setPosition = function (a, u) {
    this._px = null;
    this._py = null;
    if (a == "right" || a == "bottom") {
        this.pos = a;
    } else {
        this.pos = "int";
        if (typeof a != "undefined" && !isNaN(a)) {
            this.base.style.left = a + "px";
            this._px = a;
        }
        if (typeof u != "undefined" && !isNaN(u)) {
            this.base.style.top = u + "px";
            this._py = u;
        }
        this._ifrSize();
    }
};
dhtmlXCalendarObject.prototype._show = function (C, u) {
    if (u === true && this._activeInp == C && this._isVisible()) {
        this._hide();
        return;
    }
    this.base.style.visibility = "hidden";
    this.base.style.display = "";
    if (!C) {
        if (this._px != null && this._py != null) {
            this.base.style.left = this._px + "px";
            this.base.style.top = this._py + "px";
        } else {
            this.base.style.left = "0px";
            this.base.style.top = "0px";
        }
    } else {
        if (this.base.className.indexOf("dhtmlxcalendar_in_input") == -1) {
            this.base.className += " dhtmlxcalendar_in_input";
        }
        var v = this.i[C].input || this.i[C].button;
        var D = dhx4.screenDim();
        var A = {top: dhx4.absTop(v), left: dhx4.absLeft(v)};
        if (this.pos == "right") {
            this.base.style.left = A.left + v.offsetWidth + "px";
            this.base.style.top =
                Math.min(A.top, D.bottom - this.base.offsetHeight) + "px";
        } else {
            if (this.pos == "bottom") {
                var y = A.top + v.offsetHeight + 1;
                if (y + this.base.offsetHeight > D.bottom) {
                    var w = A.top - this.base.offsetHeight;
                    if (w >= -20) {
                        y = w;
                    }
                }
                var a = A.left;
                if (a + this.base.offsetWidth > D.right) {
                    a = Math.max(0, A.left + v.offsetWidth - this.base.offsetWidth);
                }
                this.base.style.left = a + "px";
                this.base.style.top = y + "px";
            } else {
                this.base.style.left = (this._px || 0) + "px";
                this.base.style.top = (this._py || 0) + "px";
            }
        }
        this._activeInp = C;
        v = null;
    }
    this._hideSelector();
    this.base.style.visibility = "visible";

    this.base.style.zIndex = GoingUtils.getCurMaxZIndex();
    this._ifrSize();
    if (this._ifr) {
        this._ifr.style.display = "";
    }
    this.callEvent("onShow", []);
};
dhtmlXCalendarObject.prototype._hide = function () {
    if (this._lastHover != null) {
        this._clearDayHover();
    }
    this._hideSelector();
    this.base.style.display = "none";
    dhx4.zim.clear(this.conf.zi);
    if (this.base.className.indexOf("dhtmlxcalendar_in_input") >= 0) {
        this.base.className = this.base.className.replace(/\s{0,}dhtmlxcalendar_in_input/gi, "");
    }
    this._activeInp = null;
    if (this._ifr) {
        this._ifr.style.display = "none";
    }
    this.callEvent("onHide", []);
};
dhtmlXCalendarObject.prototype._isVisible = function () {
    return this.base.style.display != "none";
};
dhtmlXCalendarObject.prototype.setInsensitiveDays = function (v) {
    var a = this._extractDates(v);
    for (var u = 0; u < a.length; u++) {
        this._rangeSet[new Date(a[u].getFullYear(), a[u].getMonth(), a[u].getDate(), 0, 0, 0, 0).getTime()] = true;
    }
    this._drawMonth(this._activeMonth);
};
dhtmlXCalendarObject.prototype.clearInsensitiveDays = function () {
    this._clearRangeSet();
    this._drawMonth(this._activeMonth);
};
dhtmlXCalendarObject.prototype.setHolidays = function (u) {
    if (u == null) {
        this._clearHolidays();
    } else {
        if (u != null) {
            var a = this._extractDates(u);
            for (var v = 0; v < a.length; v++) {
                this._holidays[new Date(a[v].getFullYear(), a[v].getMonth(), a[v].getDate(), 0, 0, 0, 0).getTime()] = true;
            }
        }
    }
    this._drawMonth(this._activeMonth);
};
dhtmlXCalendarObject.prototype._extractDates = function (v) {
    if (typeof v == "string" || v instanceof Date) {
        v = [v];
    }
    var u = [];
    for (var x = 0; x < v.length; x++) {
        if (typeof v[x] == "string") {
            var y = v[x].split(",");
            for (var a = 0; a < y.length; a++) {
                u.push(this._strToDate(y[a]));
            }
        } else {
            if (v[x] instanceof Date) {
                u.push(v[x]);
            }
        }
    }
    return u;
};
dhtmlXCalendarObject.prototype._clearRange = function () {
    this._rangeActive = false;
    this._rangeType = null;
    this._rangeFrom = null;
    this._rangeTo = null;
};
dhtmlXCalendarObject.prototype._clearRangeSet = function () {
    for (var u in this._rangeSet) {
        this._rangeSet[u] = null;
        delete this._rangeSet[u];
    }
};
dhtmlXCalendarObject.prototype._clearHolidays = function () {
    for (var u in this._holidays) {
        this._holidays[u] = null;
        delete this._holidays[u];
    }
};
dhtmlXCalendarObject.prototype._isOutOfRange = function (u) {
    if (this._rangeSet[u] == true) {
        return true;
    }
    if (this._rangeActive) {
        if (this._rangeType == "in" &&
            (u < this._rangeFrom || u > this._rangeTo)) {
            return true;
        }
        if (this._rangeType == "out" &&
            (u >= this._rangeFrom && u <= this._rangeTo)) {
            return true;
        }
        if (this._rangeType == "from" && u < this._rangeFrom) {
            return true;
        }
        if (this._rangeType == "to" && u > this._rangeTo) {
            return true;
        }
    }
    var a = new Date(u);
    if (this._rangeWeek) {
        if (this._rangeWeekData[a.getDay()] === true) {
            return true;
        }
    }
    if (this._rangeMonth) {
        if (this._rangeMonthData[a.getDate()] === true) {
            return true;
        }
    }
    if (this._rangeYear) {
        if (this._rangeYearData[a.getMonth() + "_" + a.getDate()] === true) {
            return true;
        }
    }
    return false;
};
dhtmlXCalendarObject.prototype.clearSensitiveRange = function () {
    this._clearRange();
    this._drawMonth(this._activeMonth);
};
dhtmlXCalendarObject.prototype.setSensitiveRange = function (w, v, a) {
    var u = false;
    if (w != null && v != null) {
        if (!(w instanceof Date)) {
            w = this._strToDate(w);
        }
        if (!(v instanceof Date)) {
            v = this._strToDate(v);
        }
        if (w.getTime() > v.getTime()) {
            return;
        }
        this._rangeFrom = new Date(w.getFullYear(), w.getMonth(), w.getDate(), 0, 0, 0, 0).getTime();
        this._rangeTo = new Date(v.getFullYear(), v.getMonth(), v.getDate(), 0, 0, 0, 0).getTime();
        this._rangeActive = true;
        this._rangeType = "in";
        u = true;
    }
    if (!u && w != null && v == null) {
        if (!(w instanceof Date)) {
            w = this._strToDate(w);
        }
        this._rangeFrom = new Date(w.getFullYear(), w.getMonth(), w.getDate(), 0, 0, 0, 0).getTime();
        this._rangeTo = null;
        if (a === true) {
            this._rangeFrom++;
        }
        this._rangeActive = true;
        this._rangeType = "from";
        u = true;
    }
    if (!u && w == null && v != null) {
        if (!(v instanceof Date)) {
            v = this._strToDate(v);
        }
        this._rangeFrom = null;
        this._rangeTo = new Date(v.getFullYear(), v.getMonth(), v.getDate(), 0, 0, 0, 0).getTime();
        if (a === true) {
            this._rangeTo--;
        }
        this._rangeActive = true;
        this._rangeType = "to";
        u = true;
    }
    if (u) {
        this._drawMonth(this._activeMonth);
    }
};
dhtmlXCalendarObject.prototype.setInsensitiveRange = function (u, a) {
    if (u != null && a != null) {
        if (!(u instanceof Date)) {
            u = this._strToDate(u);
        }
        if (!(a instanceof Date)) {
            a = this._strToDate(a);
        }
        if (u.getTime() > a.getTime()) {
            return;
        }
        this._rangeFrom = new Date(u.getFullYear(), u.getMonth(), u.getDate(), 0, 0, 0, 0).getTime();
        this._rangeTo = new Date(a.getFullYear(), a.getMonth(), a.getDate(), 0, 0, 0, 0).getTime();
        this._rangeActive = true;
        this._rangeType = "out";
        this._drawMonth(this._activeMonth);
        return;
    }
    if (u != null && a == null) {
        this.setSensitiveRange(null, u, true);
        return;
    }
    if (u == null && a != null) {
        this.setSensitiveRange(a, null, true);
        return;
    }
};
dhtmlXCalendarObject.prototype.disableDays = function (y, x) {
    if (y == "week") {
        if (typeof x != "object" && typeof x.length == "undefined") {
            x = [x];
        }
        if (!this._rangeWeekData) {
            this._rangeWeekData = {};
        }
        for (var u in this._rangeWeekData) {
            this._rangeWeekData[u] = false;
            delete this._rangeWeekData[u];
        }
        for (var w = 0; w < x.length; w++) {
            this._rangeWeekData[x[w]] = true;
            if (x[w] == 7) {
                this._rangeWeekData[0] = true;
            }
        }
        this._rangeWeek = true;
    }
    if (y == "month") {
        if (typeof x != "object" && typeof x.length == "undefined") {
            x = [x];
        }
        if (!this._rangeMonthData) {
            this._rangeMonthData = {};
        }
        for (var u_4 in this._rangeMonthData) {
            this._rangeMonthData[u_4] = false;
            delete this._rangeMonthData[u_4];
        }
        for (var w_1 = 0; w_1 < x.length; w_1++) {
            this._rangeMonthData[x[w_1]] = true;
        }
        this._rangeMonth = true;
    }
    if (y == "year") {
        var v = this._extractDates(x);
        if (!this._rangeYearData) {
            this._rangeYearData = {};
        }
        for (var u_5 in this._rangeYearData) {
            this._rangeYearData[u_5] = false;
            delete this._rangeYearData[u_5];
        }
        for (var w_2 = 0; w_2 < v.length; w_2++) {
            this._rangeYearData[v[w_2].getMonth() + "_" + v[w_2].getDate()] = true;
        }
        this._rangeYear = true;
    }
    this._drawMonth(this._activeMonth);
};
dhtmlXCalendarObject.prototype.enableDays = function (a) {
    if (a == "week") {
        this._rangeWeek = false;
    }
    if (a == "month") {
        this._rangeMonth = false;
    }
    if (a == "year") {
        this._rangeYear = false;
    }
    this._drawMonth(this._activeMonth);
};
dhtmlXCalendarObject.prototype.setTooltip = function (v, y, A, a) {
    var w = this._extractDates(v);
    for (var x = 0; x < w.length; x++) {
        var u = new Date(w[x].getFullYear(), w[x].getMonth(), w[x].getDate(), 0, 0, 0, 0).getTime();
        this._tipData[u] = {text: y, showIcon: A, usePopup: a};
    }
    this._drawMonth(this._activeMonth);
};
dhtmlXCalendarObject.prototype.clearTooltip = function (u) {
    var v = this._extractDates(u);
    for (var w = 0; w < v.length; w++) {
        var a = new Date(v[w].getFullYear(), v[w].getMonth(), v[w].getDate(), 0, 0, 0, 0).getTime();
        this._tipData[a] = null;
        delete this._tipData[a];
    }
    this._drawMonth(this._activeMonth);
};
dhtmlXCalendarObject.prototype._initTooltipPopup = function () {
    if (this._tipEvs) {
        return;
    }
    this.attachEvent("onMouseOver", function (u) {
        var a = new Date(u.getFullYear(), u.getMonth(), u.getDate(), 0, 0, 0, 0).getTime();
       
        if (this._tipData[a] != null) {
           
            if (this._tipTM) {
               
                window.clearTimeout(this._tipTM);
            }
           
            this._tipCellDate = u;
           
            this._tipCellDim = this.getCellDimension(u);
           
            this._tipText = this._tipData[a].text;
           
            this._tipTM = window.setTimeout(
               
                this._showTooltipPopup,
               
                this._tipTMTime);
        }
    });
    this.attachEvent("onMouseOut", this._hideTooltipPopup);
    this._tipEvs = true;
};
dhtmlXCalendarObject.prototype._showTooltipPopup = function (A, a, C, u, v) {
    var h = this;
    if (!h._tipPopup) {
        h._tipPopup = new dhtmlXPopup({mode: "top"});
    }
    h._tipPopup.attachHTML(h._tipText);
    h._tipPopup.show(h._tipCellDim.x, h._tipCellDim.y, h._tipCellDim.w, h._tipCellDim.h);
    h.callEvent("onPopupShow", [h._tipCellDate]);
};
dhtmlXCalendarObject.prototype._hideTooltipPopup = function () {
    if (this._tipTM) {
        window.clearTimeout(this._tipTM);
    }
    if (this._tipPopup != null && this._tipPopup.isVisible()) {
        this._tipPopup.hide();
        this.callEvent("onPopupHide", [this._tipCellDate]);
    }
};
dhtmlXCalendarObject.prototype.getPopup = function () {
    return this._tipPopup;
};
dhtmlXCalendarObject.prototype.getCellDimension = function (v) {
    if (typeof v == "string") {
        v = this._strToDate(v);
    }
    if (!(v instanceof Date)) {
        return null;
    }
    var x = new Date(v.getFullYear(), v.getMonth(), v.getDate(), 0, 0, 0, 0).getTime();
    var u = null;
    for (var y = 0; y < this.contDates.childNodes.length; y++) {
        for (var a = 0; a < this.contDates.childNodes[y].childNodes.length; a++) {
            var A = this.contDates.childNodes[y].childNodes[a];
            if (A._date != null && A._date.getTime() == x) {
                u = {
                    x: dhx4.absLeft(A),
                    y: dhx4.absTop(A),
                    w: A.offsetWidth,
                    h: A.offsetHeight
                };
            }
            A = null;
        }
    }
    return u;
};
dhtmlXCalendarObject.prototype._updateFromInput = function (a) {
    if (this._nullInInput && a.value.replace(/\s/g, "").length == 0) {
        if (this.checkEvent("onBeforeChange")) {
            if (!this.callEvent("onBeforeChange", [null])) {
                this._updateInp();
                return;
            }
        }
        this.setDate(null);
    } else {
        this._updateDateStr(a.value);
    }
    a = null;
};
dhtmlXCalendarObject.prototype.attachObj = function (v) {
    var u = dhx4.newId();
    if (typeof v == "string") {
        this.i[u] = {input: document.getElementById(v)};
    } else {
        if (typeof v.tagName != "undefined") {
            this.i[u] = {input: v};
        } else {
            if (typeof v == "object" && (v.input != null || v.button != null)) {
                this.i[u] = {};
                if (v.input != null) {
                    this.i[u].input =
                        typeof v.input == "string"
                            ? document.getElementById(v.input)
                            : v.input;
                }
                if (v.button != null) {
                    this.i[u].button =
                        typeof v.button == "string"
                            ? document.getElementById(v.button)
                            : v.button;
                }
            }
        }
    }
    this._attachEventsToObject(u);
    return u;
};
dhtmlXCalendarObject.prototype.detachObj = function (w) {
    var v = null;
    if (this.i[w] != null) {
        v = w;
    } else {
        if (typeof w == "string") {
            w = document.getElementById(w);
            v = w._dhtmlxcalendar_uid;
        } else {
            if (typeof w.tagName != "undefined") {
                v = w._dhtmlxcalendar_uid;
            } else {
                if (typeof w == "object" && (w.input != null || w.button != null)) {
                    if (v == null && w.input != null) {
                        v = (typeof w.input == "string"
                            ? document.getElementById(w.input)
                            : w.input)._dhtmlxcalendar_uid;
                    }
                    if (v == null && w.button != null) {
                        v = (typeof w.button == "string"
                            ? document.getElementById(w.button)
                            : w.button)._dhtmlxcalendar_uid;
                    }
                }
            }
        }
    }
    if (v != null && this.i[v] != null) {
        this._detachEventsFromObject(v);
       
        for (var u in this.i[v]) {
            this.i[v][u]._dhtmlxcalendar_uid = null;
            this.i[v][u] = null;
            delete this.i[v][u];
        }
        this.i[v] = null;
        delete this.i[v];
        return true;
    }
    return false;
};
dhtmlXCalendarObject.prototype._updateInp = function () {
    if (this.i != null &&
        this._activeInp != null &&
        this.i[this._activeInp] != null &&
        this.i[this._activeInp].input != null) {
        this.i[this._activeInp].input.value = this.getFormatedDate();
    }
};
dhtmlXCalendarObject.prototype._listenerEvBlur = function (u) {
    u = u || event;
    var a = u.target || u.srcElement;
    a._f0 = false;
    a = null;
};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXCalendar/dhtmlXCalendarMethod.js